import React from 'react'
import { Button, Card } from 'react-bootstrap'
import { isMobile } from 'react-device-detect'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import hooks from '../../../hooks'
import HideButton from './hide-button'

const FooterPrompt = () => {
    const [isVisible, setVisible] = React.useState(true)
    const { toLocation } = hooks.useClientLocation()
    const onClick = React.useCallback(() => {
        setVisible(false)
        toLocation(CLIENT_ENDPOINTS.MOBILE)
    }, [toLocation])

    if (!isMobile || !isVisible) {
        return null
    }
    return (
        <div
            style={{
                position: 'fixed',
                left: '0',
                bottom: '0',
                width: '100%',
                textAlign: 'center',
                marginBottom: '55px',
            }}
        >
            <Card>
                <Card.Header>
                    <HideButton onClick={() => setVisible(false)} />
                    <Button variant="link" onClick={onClick}>Click here to download the app!</Button>
                </Card.Header>
            </Card>
        </div>
    )
}

export default FooterPrompt